export default __webpack_public_path__ + "static/media/vf-in-progress.dda81bbd.svg";